
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/allprojects",
      function () {
        return require("private-next-pages/allprojects.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/allprojects"])
      });
    }
  